import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Zondicon from "vue-zondicons";
import FlashMessage from "@smartweb/vue-flash-message";
import notivuecation from "notivuecation";
import GlobalLoader from "./mixins/global-loader";
// import lokiNotes from './plugins/loki-notes';
import openpgpKeys from "./plugins/openpgp-keys";
import "./main.css";

// Vue.use(pouchDox);
// Vue.use(lokiNotes);
Vue.use(openpgpKeys);
Vue.mixin(GlobalLoader);
Vue.use(notivuecation);
Vue.use(FlashMessage);
Vue.component("Zondicon", Zondicon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
